import canvas from '@classes/canvas'
import type { GaugeDrawResult } from '@components/Meter/gauges/gauge_types'
import { MeterId } from '@constants/gauges_meters_consts'
import Logger from '@logger'
import { degreesToRadians } from '@turf/helpers'

import { getUnitDx } from '../helper/canvasDraw'
import type { MainParams, StyleParams } from '../Meter'

const logger = Logger.create('Gauges/Compass')

export function drawCompassGauge (main: MainParams, style: StyleParams): GaugeDrawResult {
  const { prevValue, value, center, radius, dpx, ctx, unit, redraw } = main
  const { arcColor, color } = style
  let startAngle: number, progressAngle: number

  const lengthInDegrees = 40
  const from = Number(prevValue)
  const to = Number(value)

  const drawingBlock = (current: number) => {
    startAngle = degreesToRadians(current - lengthInDegrees / 2 - 90)
    progressAngle = degreesToRadians(current + lengthInDegrees / 2 - 90)

    logger.debug(`startAngle=${startAngle}, progressAngle=${progressAngle}`)

    const n = canvas.xy(-current, center, radius - dpx * 13)
    const e = canvas.xy(-current + 90, center, radius - dpx * 13)
    const s = canvas.xy(-current + 180, center, radius - dpx * 13)
    const w = canvas.xy(-current + 270, center, radius - dpx * 13)

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)

    for (let i = 0; i <= 360; i += 10) {
      const start = canvas.xy(-current + i, center, radius - dpx)
      const end = canvas.xy(-current + i, center, radius - dpx * 5)

      if (i % 90 === 0) {
        canvas.drawLine(ctx, start.x, start.y, end.x, end.y, '#f7f7f7', dpx)
      }
      canvas.drawLine(ctx, start.x, start.y, end.x, end.y, '#3A3A3A', dpx)
    }
    canvas.drawText(ctx, n.x, n.y, 'N', dpx * 9, color)
    canvas.drawText(ctx, e.x, e.y, 'E', dpx * 9, color)
    canvas.drawText(ctx, s.x, s.y, 'S', dpx * 9, color)
    canvas.drawText(ctx, w.x, w.y, 'W', dpx * 9, color)
    unit && canvas.drawUnit(ctx, center, center - center / 3, unit, dpx * 9, color)
    canvas.drawArc(ctx, center, center, radius, 0, Math.PI * 2, arcColor)
    redraw(getUnitDx(current))
  }

  const animateId = canvas.animate(from, to, drawingBlock, 2, MeterId.COMPASS)
  return { animateId, newCurrentValue: to }
}
